<template>
  <div class="offer-content-body">
    <carousel :items="items" :margin="margin" :loop="loop" :autoplay="autoplay" :nav="nav" :navText="navText" :data="data" :responsive="responsive" :dots="dots">
      <div class="single-offer-product" v-for="(item,i) in data" :key="i">
          <div class="offer-img">
            <img :src="item.img" alt="feature-logo">
          </div>
          <div class="offer-txt">
            <div class="quick-icon">
              <router-link :to="item.content.details"><i class="fa fa-search"></i> </router-link>
              <router-link :to="item.content.details"> <i class="fa fa-heart-o"></i> </router-link>
            </div>
            <h2 class="pName"><router-link :to="item.content.details">{{item.content.title}}</router-link></h2>
            <p>{{item.content.offerPrice}} <del>{{item.content.oldPrice}}</del></p>
            <router-link class="addCart" :to="item.content.link"><i class="fa fa-shopping-cart"></i> {{item.content.btn}}</router-link>
          </div>
      </div>
    </carousel>
  </div>
</template>

<script>

  import carousel from 'vue-owl-carousel'

  export default {
    components: { carousel },
    props: {
      data: {
        type : Array,
        default: () => []
      },
      items: {
        type: Number
      },
      margin: {
        type: Number
      },
      loop: {
        type : Boolean
      },
      autoplay: {
        type : Boolean
      },
      nav : {
        type: Boolean,
        default: false
      },
      navText : {
        type : Array,
        default: () => []
      },
      dots : {
        type: Boolean,
        default: true
      },
      responsive : {
        type: Object,
        default: {}
      }
    }
  }
</script>

<style>
  .offer-content-body {
   background: #fff;
   padding: 10px 30px;
   margin-bottom: 30px;
  }
  .single-offer-product{
    overflow: hidden;
    -webkit-transition: all .3s ease-out;
   -moz-transition: all .3s ease-out;
   -ms-transition: all .3s ease-out;
   -o-transition: all .3s ease-out;
   transition: all .3s ease-out;
       padding: 10px;
  }
  .offer-img{overflow: hidden;}
  .offer-img>img {
    height: 220px;
    width: 100%;
    -webkit-transition: all .3s ease-out;
   -moz-transition: all .3s ease-out;
   -ms-transition: all .3s ease-out;
   -o-transition: all .3s ease-out;
   transition: all .3s ease-out;
  }

.quick-icon{
      margin-top: -32px;
      transform: scale(.5,.5);
      opacity: 0;

    -webkit-transition: all .3s ease-out;
   -moz-transition: all .3s ease-out;
   -ms-transition: all .3s ease-out;
   -o-transition: all .3s ease-out;
   transition: all .3s ease-out;
}

.quick-icon>a {
    display: inline-block;
    border-radius: 50%;
    background: #eee;
    height: 35px;
    width: 35px;
    line-height: 35px;
      margin: 5px ;
    color: #9e9e9e;


}


  .offer-txt {
    margin: 10px;
    text-align: center
  }

  .offer-txt>.pName{
   line-height: 18px;
  }
  .offer-txt h2 a {
    font-size: 16px;
    text-transform: capitalize;
  }
  .offer-txt del {
    color: #ddd;
  }

  .offer-txt p {
    font-size: 18px;
    margin: 0px;
        border-bottom: 1px solid #e0e0e0;
  }

  .offer-txt p del{margin-left: 5px;}

  .offer-txt>a.addCart{
    font-size: 14px;
    text-transform: capitalize;
    -webkit-transition: all .3s ease-out;
   -moz-transition: all .3s ease-out;
   -ms-transition: all .3s ease-out;
   -o-transition: all .3s ease-out;
   transition: all .3s ease-out;
       display: block;
    padding-top: 8px;
    transform: scale(.5,.5);
    opacity: 0;
  }

  .single-offer-product:hover{
    box-shadow: 0 2px 5px rgba(0,0,0,.2);
  }


  .single-offer-product:hover .offer-txt>a.addCart{
    color: #eb1b33;
      transform: scale(1,1);
    opacity: 1;
  }
  .single-offer-product:hover .quick-icon{
      margin-top: -32px;
      transform: scale(1,1);
      opacity: 1;
}

</style>
